import { render, staticRenderFns } from "./HarmonyCard.vue?vue&type=template&id=4956aa68&scoped=true"
import script from "./HarmonyCard.vue?vue&type=script&lang=js"
export * from "./HarmonyCard.vue?vue&type=script&lang=js"
import style0 from "./HarmonyCard.vue?vue&type=style&index=0&id=4956aa68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956aa68",
  null
  
)

export default component.exports